import memoize from 'transmute/memoize';
import { buildSenderLocator } from './buildSenderLocator';
export const findSender = memoize((senderId, senderType, senders) => {
  if (!senderType) {
    return null;
  }
  return senders.get(buildSenderLocator(senderType, senderId));
});